import { LinkProps } from 'next/link';
import React, {ComponentPropsWithRef, FC, ReactNode} from 'react';
import { BasicLink } from '@components/buttons/BasicLink/BasicLink.component';
import { TextProps } from '@components/Text/Text.types';
import classnames from 'classnames';

interface Props extends Omit<ComponentPropsWithRef<'a'>, 'href' | 'children'> {
  active?: boolean;
  linkProps: Pick<LinkProps, 'href' | 'as' | 'prefetch'>;
  variant?: TextProps['variant'];
  i18nKey: string;
  children?: ReactNode;
}

const MenuLink: FC<Props> = ({ variant = 'menu-link', active, linkProps, i18nKey, className, ...rest }) => {
  const rootClassName = classnames(className, { active });
  const { as, href, prefetch } = linkProps;
  return (
    <BasicLink
      as={as}
      className={rootClassName}
      href={href}
      prefetch={prefetch}
      role="menuitem"
      textProps={{ flavour: 'dark', i18nKey, variant }}
      {...rest}
    />
  );
};

export { MenuLink };
